import { css } from 'twin.macro';
export const statusConfig = {
    processing: { color: '', bgColor: '', text: 'Processing' },
    // processing: { color: '#3B82F6', bgColor: '#DBEAFE', text: 'Processing' },
    pending_approval: { color: '#F59E0B', bgColor: '#FEF3C7', text: 'Pending Approval' },
    approved: { color: '#10B981', bgColor: '#D1FAE5', text: 'Approved' },
    rejected: { color: '#EF4444', bgColor: '#FEE2E2', text: 'Rejected' },
    // paid: { color: '#8B5CF6', bgColor: '#EDE9FE', text: 'Paid' },
};

export const getStatusBadge = (status) => {
    const config = statusConfig[status] || {};

    return (
        <span
            css={css`
                padding: 4px 8px;
                border-radius: 12px;
                font-size: 12px;
                font-weight: 500;
                color: ${config.color};
                background-color: ${config.bgColor};
                border: 1px solid ${config.color};
                display: inline-block;
            `}
        >
            {config?.text || status}
        </span>
    );
};
